export default {
  back: 'Volver al menú',
  menu: 'Menú',
};
